module.exports = ".my-legends {\n  display: block;\n  padding: 20px;\n  text-align: center;\n  border-radius: 5px; }\n  .my-legends div {\n    font-weight: 500; }\n  .my-legends small {\n    color: #555 !important;\n    font-weight: 300;\n    font-size: .9em; }\n  .my-legends:hover {\n    cursor: pointer;\n    outline: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/challenges-charts/challenges-charts.component.scss
// module id = ./src/app/shared/challenges-charts/challenges-charts.component.scss
// module chunks = main